<template>
    <b-modal id="new-project" centered scrollable hide-footer modal-class="modal-full-height">
        <template  #modal-title>
            <span tabindex="0">New Project</span>
        </template>
        <b-row role="dialog" no-gutters>
            <b-col cols="12" tabindex="0">
                Please select the type of project you would like to create
            </b-col>
        </b-row>
        <b-row role="dialog" no-gutters class="mt-2">
            <b-col :key="project.index" v-for="project in projects" class="mb-3">
                <project-card :url="project.url" :image="project.image" :label="project.label"
                              :text="project.text"></project-card>
            </b-col>
        </b-row>
    </b-modal>
</template>

<script>

    import ProjectCard from "./ProjectCard/ProjectCard";

    export default {
        name: "ProjectSelection",
        components: {ProjectCard},
        data: function () {
            return {
                projects: [
                    {
                        index: 1,
                        text: 'JA Job Shadow',
                        url: 'js_start_project',
                        label: 'J.A. Job Shadow.',
                        image: 'ja-job-shadow.jpg'
                    },
                    {
                        index: 2,
                        text: 'JA Be Entreprenurial',
                        url: 'be_start_project',
                        label: 'J.A. Be Entreprenurial.',
                        image: 'ja-be-entreprenurial.jpg'
                    },
                    {
                        index:3,
                        text: 'Design for Delight',
                        url: 'start_project',
                        label: 'Design for Delight.',
                        image: 'design-for-delight.svg'
                    }
                ]
            }
        }
    }
</script>